(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heritage-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Enhance <details> accordions: optional single-open behavior.
  document.querySelectorAll('.heritage-faq__list[data-close-others="true"]').forEach(function (list) {
    var items = list.querySelectorAll('.heritage-faq__item');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item && other.open) other.open = false;
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heritage-insta-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('heritage-insta-video')) return;
    class HeritageInstaVideo extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-hig-track]');
        this.videos = Array.from(this.querySelectorAll('[data-hig-video]'));
        this.prev = this.querySelector('[data-hig-prev]');
        this.next = this.querySelector('[data-hig-next]');
        this.autoplay = this.getAttribute('data-autoplay') !== 'false';
        this.unmuted = null;
        this.onScroll = this.onScroll.bind(this);
        this.updateArrows = this.updateArrows.bind(this);
        if (this.prev) this.prev.addEventListener('click', () => this.scrollByItem(-1));
        if (this.next) this.next.addEventListener('click', () => this.scrollByItem(1));
        if (this.track) {
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.updateArrows, { passive: true });
        }
        this.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-hig-sound]');
          if (!btn) return;
          e.preventDefault();
          this.toggleSound(btn);
        });
        this.setupAutoplay();
        this.updateArrows();
      }
      disconnectedCallback() { if (this.io) this.io.disconnect(); window.removeEventListener('resize', this.updateArrows); }
      setupAutoplay() {
        if (!this.videos.length) return;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!this.autoplay || reduced || !('IntersectionObserver' in window)) return;
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const v = entry.target;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) { const p = v.play(); if (p && p.catch) p.catch(() => {}); }
            else { v.pause(); if (this.unmuted === v) this.muteAll(); }
          });
        }, { threshold: [0, 0.5, 1] });
        this.videos.forEach((v) => this.io.observe(v));
      }
      toggleSound(btn) {
        const item = btn.closest('.hig__item');
        const v = item && item.querySelector('[data-hig-video]');
        if (!v) return;
        const willUnmute = v.muted;
        this.muteAll();
        if (willUnmute) {
          v.muted = false; v.volume = 1; this.unmuted = v;
          btn.setAttribute('aria-pressed', 'true'); btn.setAttribute('aria-label', 'Sesi kapat');
          const p = v.play(); if (p && p.catch) p.catch(() => {});
        }
      }
      muteAll() {
        this.videos.forEach((v) => { v.muted = true; });
        this.querySelectorAll('[data-hig-sound]').forEach((b) => { b.setAttribute('aria-pressed', 'false'); b.setAttribute('aria-label', 'Sesi aç'); });
        this.unmuted = null;
      }
      itemWidth() {
        const first = this.track && this.track.querySelector('.hig__item');
        if (!first) return 0;
        const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 0;
        return first.getBoundingClientRect().width + gap;
      }
      scrollByItem(dir) { if (this.track) this.track.scrollBy({ left: dir * this.itemWidth(), behavior: 'smooth' }); }
      onScroll() { if (this.raf) return; this.raf = requestAnimationFrame(() => { this.raf = null; this.updateArrows(); }); }
      updateArrows() {
        if (!this.track) return;
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        if (this.prev) this.prev.toggleAttribute('disabled', this.track.scrollLeft <= 2);
        if (this.next) this.next.toggleAttribute('disabled', this.track.scrollLeft >= max);
      }
    }
    customElements.define('heritage-insta-video', HeritageInstaVideo);
    document.addEventListener('shopify:section:load', (e) => {
      const el = e.target && e.target.querySelector && e.target.querySelector('heritage-insta-video');
      if (el && el.updateArrows) el.updateArrows();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lcw-banner-grid"] && !Shopify.designMode) return;
  try {
    
  // <lcw-banner-grid>: mobile carousel dots driven by IntersectionObserver.
  // Custom element re-initialises on its own when the theme editor
  // re-renders the section (shopify:section:load); the explicit listener
  // below only refreshes state for already-connected instances.
  if (!customElements.get('lcw-banner-grid')) {
    class LcwBannerGrid extends HTMLElement {
      constructor() {
        super();
        this.onDotClick = this.onDotClick.bind(this);
      }

      connectedCallback() {
        this.track = this.querySelector('[data-lcw-track]');
        this.tiles = Array.from(this.querySelectorAll('[data-lcw-tile]'));
        this.dots = Array.from(this.querySelectorAll('[data-lcw-dot]'));
        if (!this.track || this.dots.length === 0) return;

        this.dots.forEach((dot) => dot.addEventListener('click', this.onDotClick));
        this.setupObserver();
      }

      disconnectedCallback() {
        this.teardown();
      }

      teardown() {
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
        if (this.dots) {
          this.dots.forEach((dot) => dot.removeEventListener('click', this.onDotClick));
        }
      }

      setupObserver() {
        if (this.observer) this.observer.disconnect();
        if (!('IntersectionObserver' in window)) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const index = Number(entry.target.dataset.index);
              this.setActive(index);
            });
          },
          { root: this.track, threshold: 0.6 }
        );

        this.tiles.forEach((tile) => this.observer.observe(tile));
      }

      setActive(index) {
        this.dots.forEach((dot) => {
          const isActive = Number(dot.dataset.index) === index;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      }

      onDotClick(event) {
        const index = Number(event.currentTarget.dataset.index);
        const tile = this.tiles[index];
        if (!tile || !this.track) return;
        this.track.scrollTo({ left: tile.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        this.setActive(index);
      }

      refresh() {
        this.teardown();
        this.connectedCallback();
      }
    }

    customElements.define('lcw-banner-grid', LcwBannerGrid);

    // Theme editor: re-init dots after a section reload / block change.
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('lcw-banner-grid').forEach((grid) => {
        if (typeof grid.refresh === 'function') grid.refresh();
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
